module.exports = __webpack_public_path__ + "static/media/gain_weight.7c8a1bdb.png";